<script lang="ts">
    export let color1:any = [0, 0, 0];
    export let color2:any = [0, 0, 0];
    export let color3:any = [0, 0, 0];

    $: color1hsl = 'hsl(' + color1[0] + ', ' + color1[1] + '%, ' + 50 + '%)';
    $: color2hsl = 'hsl(' + color2[0] + ', ' + color2[1] + '%, ' + 50 + '%)';
    $: color3hsl = 'hsl(' + color3[0] + ', ' + color3[1] + '%, ' + 50 + '%)';
</script>

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.29379 16.2062L12 7.5L16.5 12L7.79379 20.7062C7.60155 20.8985 7.36068 21.0348 7.09693 21.1008L3.92536 21.8937C2.82679 22.1683 1.8317 21.1732 2.10634 20.0746L2.89923 16.9031C2.96517 16.6393 3.10155 16.3985 3.29379 16.2062Z" fill="url(#paint0_linear_1163_726)" stroke="black" stroke-width="1.5"/>
    <path d="M3.29379 16.2062L12 7.5L16.5 12L7.79379 20.7062C7.60155 20.8985 7.36068 21.0348 7.09693 21.1008L3.92536 21.8937C2.82679 22.1683 1.8317 21.1732 2.10634 20.0746L2.89923 16.9031C2.96517 16.6393 3.10155 16.3985 3.29379 16.2062Z" fill="url(#paint1_linear_1163_726)"/>
    <path d="M18 13.5L10.5 6L13.5 3L15 4.5L18 1.5H19.5C21.1569 1.5 22.5 2.84315 22.5 4.5V6L19.5 9L21 10.5L18 13.5Z" fill="#363636" stroke="black" stroke-width="1.5"/>
    <path d="M22.5 6L19.5 9L15 4.5L18 1.5H19.5C21.1569 1.5 22.5 2.84315 22.5 4.5V6Z" fill="url(#paint2_linear_1163_726)"/>
    <path d="M18 13.5L10.5 6L13.5 3L21 10.5L18 13.5Z" fill="url(#paint3_linear_1163_726)"/>
    <defs>
        <linearGradient id="paint0_linear_1163_726" x1="15.75" y1="12" x2="4.5" y2="23.25" gradientUnits="userSpaceOnUse">
            <stop stop-color="{color1hsl}"/>
            <stop offset="0.482404" stop-color="{color2hsl}"/>
            <stop offset="1" stop-color="{color3hsl}"/>
        </linearGradient>
        <linearGradient id="paint1_linear_1163_726" x1="11.25" y1="7.5" x2="16.5" y2="12.75" gradientUnits="userSpaceOnUse">
            <stop stop-color="white" stop-opacity="0"/>
            <stop offset="0.28125" stop-color="white"/>
            <stop offset="0.416667" stop-color="white" stop-opacity="0"/>
            <stop offset="0.713542" stop-opacity="0.44"/>
            <stop offset="1" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint2_linear_1163_726" x1="15" y1="4.5" x2="19.5" y2="9" gradientUnits="userSpaceOnUse">
            <stop stop-color="white" stop-opacity="0.39"/>
            <stop offset="0.645833" stop-opacity="0.41"/>
            <stop offset="1" stop-color="white" stop-opacity="0"/>
        </linearGradient>
        <linearGradient id="paint3_linear_1163_726" x1="10.5" y1="6" x2="18" y2="13.5" gradientUnits="userSpaceOnUse">
            <stop stop-color="white" stop-opacity="0.39"/>
            <stop offset="0.723958" stop-opacity="0.41"/>
            <stop offset="1" stop-color="white" stop-opacity="0"/>
        </linearGradient>
    </defs>
    </svg>  